import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from 'react';

/**
 * Spread onto the email `Input` for a portfolio arrival. Read-only rather than disabled so the value
 * still submits and still reads to assistive tech. The account has to be created on the address the
 * portfolio was claimed with: the backend adopts the portfolio by matching that email, so an edited
 * address would create an account with no portfolio in it.
 */
export const PORTFOLIO_LOCKED_EMAIL_INPUT_PROPS = {
  'aria-describedby': 'portfolio-locked-email-hint',
  className: 'bg-role-surface-container text-role-on-background-subtle',
  readOnly: true
} as const;
export const PORTFOLIO_LOCKED_EMAIL_LABEL_PROPS = {
  className: 'flex items-center justify-between gap-2'
} as const;
export function PortfolioLockedEmailHint() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <span className="font-normal text-role-on-background-subtle text-xs" id="portfolio-locked-email-hint">from your portfolio</span>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}